/** What a route answers while its builder is still running. */
export type PendingBody = { pending: true; retryInMs?: number };

export function isPendingBody(body: unknown): body is PendingBody {
  return typeof body === "object" && body !== null && (body as { pending?: unknown }).pending === true;
}
